import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getCellStyles } from '../utils/getCellStyles';

interface TableCellProps {
  value: string | number;
  percent?: number;
  color?: string;
  prefix?: string;
  suffix?: string;
  descriptionValue?: string;
  description?: string;
  style?: SxProps<Theme>;
}

export const TableCell = ({
  value,
  percent,
  color,
  prefix,
  suffix,
  descriptionValue,
  description,
  style,
}: TableCellProps) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      ...(percent !== undefined && color && getCellStyles(percent, color)),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingX: theme => theme.spacing(1.25),
      paddingY: theme => theme.spacing(0.5),
      ...style,
    }}
  >
    <Box>
      {prefix}
      {value}
      {suffix}
    </Box>
    {descriptionValue && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: theme => theme.spacing(1) }}>
        {description && (
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        )}
        {descriptionValue && (
          <Typography variant="body2Bold" color="textPrimary">
            {descriptionValue}
          </Typography>
        )}
      </Box>
    )}
  </Box>
);
